import * as React from "react";

function SvgDownOpen(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23.99 13.98"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M20.91.54a1.78 1.78 0 012.55 0 1.87 1.87 0 010 2.61L13.27 13.44a1.78 1.78 0 01-2.55 0L.53 3.15a1.88 1.88 0 010-2.61 1.78 1.78 0 012.55 0L12 8.99z" />
    </svg>
  );
}

const MemoSvgDownOpen = React.memo(SvgDownOpen);
export default MemoSvgDownOpen;
